"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai-assist.suggestions.header': 'AI 建议',
    'ai-assist.suggestions.close': '关闭',
    'ai-assist.suggestions.intro': '选择一个建议应用到您的提示中：',
};
